export enum StatusTypes {
    Expirada = 1,
    NoExpirada = 2,
    NA = 3
}

export enum StatusRoomServiceTypes {
    EnPreparacion = 1,
    PorEntregar = 2,
    NA = 3,
    Entregada = 4
}

export enum StatusPagoTypes {
    Expirada = 1,
    NoExpirada = 2,
    Pagada = 3,
    NA = 4
}

export enum StatusPagoTypesWithoutPagada {
    Expirada = 1,
    NoExpirada = 2,
    NA = 4
}

export enum StatusPersonaExtraTypes {
    NoExpirada = 3,
    NA = 4
}

export enum StatusEstanciaExtraTypes {
    Expirada = 1,
    NoExpirada = 2,
    NA = 3
}

export enum StatusIsUsingExtraTime {
    Yes = 1,
    No = 2
}